import { ProjectForm } from '../../project/models/form.model';
import { formTypes } from '../../form/form.constants';
import { Examination } from './examination.model';

export class AuditApplication extends ProjectForm {
  examination: Examination;

  constructor(formIndex: number = null) {
    super(formIndex);
    this.init();
  }

  init(): AuditApplication {
    super.init();
    this.type = formTypes.rdAudit.abbrev;
    this.examination = this.examination || new Examination();
    return this;
  }

  get qualifier(): string {
    return null;
  }
}
